import React, { Component } from 'react';
import { Virtual } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import blankImage from '../../Common/blank-512x512.png';
import { getTextureUrl } from '../../Common/TextureTools';

import './Actions/action-scroller.css';
import './inventory-selector.css';
import { ASSETS_URL } from '../../../../Settings';


export default class InventorySelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            highlight: false,
            highlightedIndexes: [],
            storageCallback: null
        };
    }

    componentDidMount() {
        window.addEventListener('highlight-storage-event',
            this.highlightStorageIndexes);
        window.addEventListener('clear-storage-highlight-event',
            this.clearHighlights);
    }

    componentWillUnmount() {
        window.removeEventListener('show-manual-controls',
            this.show);
        window.removeEventListener('hide-manual-controls',
            this.hide);
    }

    highlightStorageIndexes = (e) => {
        const highlightedIndexes = e.detail.indexes;
        const storageCallback = e.detail.callback;
        this.setState({
            highlightedIndexes: highlightedIndexes,
            storageCallback: storageCallback,
        });
    }

    roomImage = (props) => {
        let src;
        if (props.texture) {
            src = getTextureUrl(props.texture);
        } else {
            src = blankImage;
        }
        return <div>
            <img
                src={src}
                alt="room"
                className={'inventory-selector-image'}
            />
            {this.state.highlightedIndexes.includes(props.index) &&
                <div className={'inventory-highlighter'} />}
        </div>
    };

    onClick = (swiper) => {
        const index = swiper.clickedIndex;
        console.log(index)
        const isValid = this.state.highlightedIndexes.includes(swiper.clickedIndex);
        if (isValid && this.state.storageCallback) {
            this.state.storageCallback(swiper.clickedIndex);
            this.clearHighlights();
        }
    };

    clearHighlights = () => {
        this.setState({
            highlight: false,
            highlightedIndexes: [],
            storageCallback: null});
    }

    render() {
        const gamePlayerData = this.props.app.game.seatedController.gamePlayerData;
        // if (this.props.gamePlayerData.storage === []) return <></>

        // let blankIndex = this.props.gamePlayerData.storage.find(undefined);
        let firstHighlightIndex = this.state.highlightedIndexes[0];
        let firstHighlighted = gamePlayerData.storage[
            firstHighlightIndex];
        let highlightStorageArea = firstHighlighted === undefined;

        let className = 'inventory-selector-swiper-container';
        if (this.state.highlight && highlightStorageArea) className += ' inventory-animated-border-dashed';

        let storage = gamePlayerData.storage;
        storage = [...storage, null];

        return (
            <div className={'action-scroller'}>
                <div className={'inventory-selector-anchor'}>
                    <div className={className}>
                        <Swiper
                            slidesPerView={6}
                            spaceBetween={0}
                            freeMode={true}
                            grabCursor={true}

                            modules={[Virtual]}

                            onSwiper={(swiper) => {
                                this.swiper = swiper;
                            }}
                            onClick={this.onClick}
                            className="action-scroller-swiper"
                        >
                            {storage.map((gridItem, index) => {
                                return <SwiperSlide key={`gi-${index}`}
                                                    virtualIndex={index}>
                                    <this.roomImage texture={gridItem}
                                                    highlightedIndexes={this.state.highlightedIndexes}
                                                    index={index}
                                    />
                                </SwiperSlide>
                            })}

                            {}


                        </Swiper>
                    </div>
                    <img
                        src={`${ASSETS_URL}overlays/InventoryOverlay-1080x210.png`}
                        alt="action"
                        className={'swiper-overlay'}
                    />
                </div>

            </div>
        )
    }
}
